{{'firmware.codeUpgrade' | translate }}